module.exports = __webpack_public_path__ + "img/post-img.b9a24157.jpg";